import { Box, Skeleton, Tag } from '@factorialco/deprecated-design-system'
import { sample } from 'lodash'

export const JobPostingStandardPortalDetailsSkeleton = () => {
  return (
    <Box
      border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
      paddingY="s16"
      paddingX="s24"
      borderRadius={{ all: 'abs010' }}
      justifyContent="spaceBetween"
      alignItems="center"
      flexDirection="row"
    >
      <Box gap="s12" flexDirection="row" alignItems="center">
        {/* channel logo */}
        <Skeleton width="s32" height="s32" />
        {/* channel name */}
        <Skeleton width={sample(['s120', 's140', 's200', 's96'])} height="s32" />
      </Box>

      <Box
        borderRadius={{ all: 'abs010' }}
        border={{ all: { color: 'grey200', style: 'solid', width: 's1' } }}
      >
        <Tag icon="person" iconColor="grey800" type="transparent" leftItem="icon">
          {/* applications count */}
          <Skeleton width="s8" height="s20" />
        </Tag>
      </Box>
    </Box>
  )
}
